import { BONUS_CLAIM_PRELOAD_URLS } from '@/components/_promo/pages/BonusClaim/helpers';
import { WELCOME_APRIL_2025_PRELOAD_URLS } from '@/components/_promo/pages/WelcomeApril2025/helpers';

export const PRELOAD_IMGS: Partial<Record<string, string[]>> = {
  BonusClaim: BONUS_CLAIM_PRELOAD_URLS,
  WelcomeApril2025: WELCOME_APRIL_2025_PRELOAD_URLS,
};

export const MAP_NAME_TO_PROMO_COMPONENT: Record<string, string> = {
  // SunOfEgypt
  'sun-of-egypt': 'SunOfEgypt',

  // BigBass
  'big-bass': 'BigBass',

  // WheelFortune
  'wheel-fortune': 'WheelFortune',

  // DogTreasure
  'dog-treasure': 'DogTreasure',

  // CrownWheel
  'crown-wheel': 'CrownWheel',

  // CrownWheelDarkReg
  'crown-wheel-dark': 'CrownWheelDarkReg',

  // CrownBanner
  'crown-banner': 'CrownBanner',

  // StarGoldCoast
  'star-gold-coast': 'StarGoldCoast',

  // WolfElvisSunBuffalo
  'wolf-elvis-sun-buffalo': 'WolfElvisSunBuffalo',

  // April2025
  analyzer40: 'April2025',

  // CrownWheelBlack
  crown: 'CrownWheelBlack',

  // JuicyCarMay2025
  free40: 'JuicyCarMay2025',

  // AviatorUp
  AVIATORUP: 'AviatorUp',

  // QuizBonusJune2025
  'quiz-bonus': 'QuizBonusJune2025',

  // BonusClaim
  'bonus-claim': 'BonusClaim',
  'bonus-claim-dark': 'BonusClaim', // dark theme
  'providers-modal-dark': 'BonusClaim', // dark theme + providers list
  'games-modal-dark': 'BonusClaim', // dark theme + games list

  // BuffaloWheel
  'buffalo-wheel': 'BuffaloWheel',

  // SlotsCircle
  lpSlotsCircle: 'SlotsCircle',

  // RegRewards
  'reg-rewards': 'RegRewards',

  // RegDragonRewards
  'reg-dragon-rewards': 'RegDragonRewards',
  fortune: 'RegDragonRewards', // diff namespace
  juicylvl: 'RegDragonRewards', // diff namespace

  // Circle
  'circle-1': 'Circle',

  // CrownReg
  'crown-reg': 'CrownReg',
  'star-reg': 'CrownReg', // diff logo

  // CryptoExclusiveMay25
  'crypto-exclusive': 'CryptoExclusiveMay25',

  // CryptoOfferMay2025
  cryptowelcome: 'CryptoOfferMay2025',

  // WelcomeApril2025
  lvl1: 'WelcomeApril2025',
  'hotice-fixedscroll': 'WelcomeApril2025', // fixed reg btn + diff namespace and imgs
  'lvl1-fixedscroll': 'WelcomeApril2025', // fixed reg btn

  // WolfWheel
  'wolf-wheel': 'WolfWheel',

  // DogTreasureTerms
  easywincode: 'DogTreasureTerms',

  // GatesOfOlympus
  'gates-of-olympus': 'GatesOfOlympus',

  // FruitCircusParty
  circus: 'FruitCircusParty',

  // WinterJanuary
  luckywinter: 'WinterJanuary',

  // CrownMarch25
  crowncode: 'CrownMarch25',

  // EasterApril2025
  spincode: 'EasterApril2025',

  // BanksBenefitsMay2025
  powerslot: 'BanksBenefitsMay2025',
  'powerslot-games': 'BanksBenefitsMay2025', // diff top games
  'powerslot-winners': 'BanksBenefitsMay2025', // show jackpot
  'lyzer40-games': 'BanksBenefitsMay2025', // diff namespace

  // FiestaJune2025
  sun35fs: 'FiestaJune2025',

  // CardsBenefitsJune2025
  grandcode: 'CardsBenefitsJune2025',
  '50zilla': 'CardsBenefitsJune2025', // diff namespace
  turbolvl: 'CardsBenefitsJune2025', // diff namespace
  jinglewin: 'CardsBenefitsJune2025', // diff namespace

  // SharkJuly25
  'lucky35fs-games': 'SharkJuly25',

  // Carways2025
  spin50: 'Carways2025',

  // CardsBenefitsAugust2025
  'doubleslot-top': 'CardsBenefitsAugust2025',
  'hotslot-d': 'CardsBenefitsAugust2025', // diff namespace + dark theme
  'doubleslot-gold': 'CardsBenefitsAugust2025', // sandGold reg theme
  'doubleslot-ndb': 'CardsBenefitsAugust2025', // no jackpot + top games and payments

  // SlotsStepsAugust2025
  'doubleslot-slot': 'SlotsStepsAugust2025',

  // TopGamesBanksBenefitsOctober2025
  'betslot-golden': 'TopGamesBanksBenefitsOctober2025',
  'betslot-green': 'TopGamesBanksBenefitsOctober2025', // green reg btn
  spooky: 'TopGamesBanksBenefitsOctober2025', // diff namespace

  //CircusNovember
  lvlcircus: 'CircusNovember',
  fruitsup: 'CircusNovember', // diff namespace

  // CardsBenefitsNovember2025
  happyslot: 'CardsBenefitsNovember2025',
  'happyslot-time': 'CardsBenefitsNovember2025', // show withdrawal time

  // DragonPearlsNovember2025
  'hotslot-s': 'DragonPearlsNovember2025',

  // XmasJanuary2026
  snowcode: 'XmasJanuary2026',
  asksnow: 'XmasJanuary2026', // with traffic

  // StValentine2026
  sweetup: 'StValentine2026',

  // DragonPearlsFebruary2026
  luxslot: 'DragonPearlsFebruary2026',
  luxzilla: 'DragonPearlsFebruary2026', // with traffic
  claimlux: 'DragonPearlsFebruary2026', // with traffic
  bonuslux: 'DragonPearlsFebruary2026', // with traffic

  // DragonPearlsMarch2026
  boost: 'DragonPearlsMarch2026',
  'boost-db': 'DragonPearlsMarch2026', // dynamic cta btn text

  // StPatrick2026
  patrickup: 'StPatrick2026',

  // EasterApril2026
  easterup: 'EasterApril2026',

  // CardsBenefitsMay2026
  royalup: 'CardsBenefitsMay2026',
  '50dragon': 'CardsBenefitsMay2026', // diff namespace

  // CardsBenefitsJuly2026
  chickenup: 'CardsBenefitsJune2026',
  auspokies: 'CardsBenefitsJune2026', // diff img + namespace
  dragon: 'CardsBenefitsJune2026', // diff img + namespace
  coinup: 'CardsBenefitsJune2026', // diff img + namespace

  slotwin: 'SlotMachineSeptember26',

  // Oktoberfest2026
  mybeer: 'Oktoberfest2026',

  // Halloween2026
  hwup: 'Halloween2026',
} as const;
